export default {
  title: 'Beschikbaarheid sluiten',
  close_availabilities_form: {
    date_range: {
      label: 'Selecteer een datum en tijd.',
    },
  },
  reason: {
    label: 'Voeg een reden toe (optioneel)',
    placeholder: 'Voer beschrijving in...',
  },
  recurring: {
    label: 'Jaarlijks terugkerend',
  },
  buttons: {
    save: 'Opslaan',
    cancel: 'Annuleren',
    add: '+ Uitzondering toevoegen',
    reactivate: 'Heractiveren',
  },
  reservations: {
    title: 'Reserveringen',
    description: 'Wilt u de schema-uitzondering toevoegen aan reserveringen?',
    add: 'Toevoegen',
    cancel: 'Annuleren',
  },
  projects: {
    online_shop: 'Online shop',
    reservations: 'Reserveringen',
    storefront: 'Storefront',
  },
  success_messages: {
    reservation_updated: 'Schema-uitzondering succesvol toegevoegd',
  },
  error_messages: {
    date_range_required: 'Selecteer een datumbereik.',
    creation_failed: 'Aanmaken van uitzondering mislukt',
    overlapping_schedule_exception: 'U heeft al een schema-uitzondering voor dat tijdbereik',
    merge_schedule_exceptions:
      'De volgende schema-uitzondering {{oldDate}} wordt samengevoegd met {{newDate}}. U kunt ook het datumbereik voor {{oldDate}} bijwerken.',
  },
};
